<template>
  <div class="page">
    <div class="container">
      <div class="page__inner">
        <p class="page__counter">03</p>
        <h1 class="subtitle subtitle_red page__subtitle">Развитие экосистемы партнерства в&nbsp;рамках решения задач</h1>
      </div>
    </div>

    <ecosystem-background />

    <page-footer
      :prev="{ name: 'dialog' }"
      :next="{ name: 'anticrisis' }"
    />
  </div>
</template>

<script>
// eslint-disable-next-line
import { TimelineMax, TweenMax } from 'gsap'
import EcosystemBackground from '@/components/servicesSvg'
import PageFooter from '@/components/PageFooter'
import RouteMixin from '../mixins/route'

export default {
  name: 'ecosystem',
  mixins: [RouteMixin],
  components: {
    EcosystemBackground,
    PageFooter
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.ecosystem-bg', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__counter', 0.3, { y: '-20px', opacity: 0 }))
      .add(TweenMax.from('.page__subtitle', 0.3, { y: '-10px', opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    this.isDisabledRoute = true

    new TimelineMax()
      .add(TweenMax.to('.page__subtitle', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__counter', 0.3, { y: '20px', opacity: 0 }))
      .add(TweenMax.to('.ecosystem-bg', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
